import { START_QUIZ_URL_FRAGMENT } from './constants';
import { OpenReplayNetworkData } from './types';

function isPlainObject(value: unknown): value is Record<string, unknown> {
	return value !== null
		&& typeof value === 'object'
		&& !Array.isArray(value)
		&& Object.getPrototypeOf(value) === Object.prototype;
}

export function sanitizeOpenReplayPayload(value: unknown): unknown {
	if (!isPlainObject(value)) {
		return value;
	}

	return {
		...value,
	};
}

function removeBodyField(value: unknown): unknown {
	if (!isPlainObject(value)) {
		return value;
	}

	return Object.entries(value).reduce<Record<string, unknown>>(
		(acc, [key, item]) => {
			if (key.toLowerCase() !== 'body') {
				acc[key] = item;
			}
			return acc;
		},
		{},
	);
}

export function sanitizeOpenReplayNetworkData(
	data: OpenReplayNetworkData,
): OpenReplayNetworkData {
	const url = typeof data.url === 'string' ? data.url : '';
	const sanitizedData = sanitizeOpenReplayPayload(data);

	if (url.includes(START_QUIZ_URL_FRAGMENT)) {
		return sanitizedData as OpenReplayNetworkData;
	}

	return removeBodyField(sanitizedData) as OpenReplayNetworkData;
}
